import { createFileRoute } from '@tanstack/react-router';
import {
  installmentDetailScreen,
  installmentDetailSearch,
  loadInstallmentMessages,
  loadInstallmentScreens,
} from '@/modules/installment/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/gestao-carteira/parcelamentos/$installmentId')({
  validateSearch: installmentDetailSearch,
  staticData: { screen: installmentDetailScreen },
  loader: () => loadInstallmentMessages(),
  component: lazyScreen(loadInstallmentScreens, 'InstallmentDetailRouteScreen'),
});
